<template>
    <NuxtLayout name="default">
        <div
            ref="cmsWrapper"
            class="w-full max-w-5xl mx-auto px-8"
        >
            <slot />

            <layout-footer class="mt-12" />
        </div>
    </NuxtLayout>
</template>
